const env = process.env.REACT_APP_CONFIG_FILE || "development";
const cfg = require(`./config.${env}`);

console.log(`in config... env: ${env}`);

module.exports = cfg;
